var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g4, _path16, _g5, _path17, _path18, _g6, _rect2, _g7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_5262)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 9.76562,
    fill: "#FFD25C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 36.7383,
    cy: 29.6289,
    rx: 37.5195,
    ry: 35.6836,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.7383,
    cy: 29.6289,
    rx: 36.7773,
    ry: 33.9648,
    fill: "#FFD25C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 36.7383,
    cy: 29.6289,
    rx: 29.4336,
    ry: 27.9883,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.7383,
    cy: 29.6289,
    rx: 24.5117,
    ry: 26.6601,
    fill: "#FFD25C"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 36.7383,
    cy: 29.6289,
    rx: 18.8477,
    ry: 18.1836,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.7383,
    cy: 29.6289,
    rx: 11.4648,
    ry: 14.1211,
    fill: "#FFD25C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.126 28.7434L7.46094 40H34.0625L29.0284 18.4742V16.8449L27.6959 9.98236H10.126V28.7434Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_102_5262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 28,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.126 28.7434L7.46094 40H34.0625L29.0284 18.4742V16.845L27.6959 9.98242H10.126V28.7434Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_102_5262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.368 35.211L34.4573 31.1132L32.1377 9.63678L8.2999 9.14307L7.11542 33.5324L18.368 35.211Z",
    fill: "#3D2E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8637 14.9304C11.5063 14.9619 11.8803 15.4351 11.987 15.6678C12.3439 15.5411 12.8929 15.2461 12.7748 14.917C12.6567 14.5879 12.2025 14.5864 11.9225 14.6472C12.2805 14.8169 12.3379 15.0717 12.3219 15.1779C11.701 14.6377 11.091 14.7878 10.8637 14.9304Z",
    fill: "#1E0D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4276 15.3881C11.0703 15.4197 11.4443 15.8929 11.551 16.1256C11.9078 15.9989 12.4569 15.7039 12.3388 15.3748C12.2207 15.0457 11.7664 15.0442 11.4865 15.1049C11.8445 15.2746 11.9019 15.5294 11.8858 15.6356C11.2649 15.0955 10.655 15.2456 10.4276 15.3881Z",
    fill: "#1E0D10"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7136,
    cy: 38.272,
    rx: 7.45238,
    ry: 7.45503,
    fill: "#FFD25C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7365,
    cy: 40.324,
    rx: 4.05044,
    ry: 5.03748,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9392 33.6675C18.6481 34.3885 18.9635 35.0444 19.1576 35.2823C18.8422 35.6077 18.1386 36.1835 17.8474 35.8831C17.5563 35.5827 17.896 34.9568 18.1022 34.6814C18.1022 35.1621 18.3448 35.3574 18.4661 35.3949C18.2041 34.4336 18.6724 33.8428 18.9392 33.6675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1196 34.8312C19.7608 34.9776 19.6429 35.3212 19.6288 35.4748C19.4007 35.4741 18.9449 35.4202 18.9462 35.2097C18.9475 34.9991 19.2902 34.9035 19.4614 34.882C19.2919 35.05 19.3103 35.2063 19.3406 35.2634C19.5854 34.8323 19.9619 34.7956 20.1196 34.8312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3485 30.144C22.6396 30.865 22.3242 31.521 22.1301 31.7588C22.4455 32.0842 23.1491 32.66 23.4403 32.3596C23.7314 32.0592 23.3918 31.4333 23.1855 31.1579C23.1855 31.6386 22.9429 31.8339 22.8216 31.8714C23.0836 30.9101 22.6154 30.3193 22.3485 30.144Z",
    fill: "#FFD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7556 33.5224C12.3034 33.3981 12.7346 33.6991 12.8817 33.8652C13.1503 33.6778 13.6423 33.2424 13.4618 32.9999C13.2813 32.7574 12.7957 32.9273 12.5755 33.0425C12.9182 33.0982 13.0294 33.2939 13.0421 33.3848C12.387 33.0866 11.9115 33.3523 11.7556 33.5224Z",
    fill: "#FFD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5776 29.5811L22.2502 26.8337C22.6211 26.7464 22.9264 26.4843 23.0687 26.1309L23.4631 25.1519C23.8203 24.2652 23.0226 23.3468 22.0946 23.5765L21.9616 23.6094C21.8695 23.6322 21.7749 23.6437 21.68 23.6437H10.7547C10.3714 23.6437 10.0124 23.8311 9.79327 24.1456L8.60661 25.8484C8.38405 26.1677 8.33459 26.5768 8.47464 26.94L9.2157 28.8619C9.42632 29.4082 10.0077 29.7152 10.5776 29.5811Z",
    fill: "#1E0D10"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.3998 23.2138L30.7558 40.0493H35.0496L31.5948 21.239L27.992 11.3154H9.78058V13.1915L26.6101 13.6358L27.3998 23.2138Z",
    fill: "#0F1511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.301 22.7202L30.509 40L30.8545 40.2469L27.301 22.7202Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_102_5262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 14,
    width: 5,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4618 14.9221C14.6599 14.9221 15.6311 15.8926 15.6311 17.0897C15.6311 17.4118 15.5609 17.7174 15.4348 17.9922C15.4045 18.0581 15.3373 18.0979 15.2648 18.0979H11.6587C11.5862 18.0979 11.519 18.0581 11.4888 17.9922C11.3627 17.7174 11.2924 17.4118 11.2924 17.0897C11.2924 15.8926 12.2637 14.9221 13.4618 14.9221Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_102_5262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4618 14.9221C14.6599 14.9221 15.6311 15.8926 15.6311 17.0897C15.6311 17.4118 15.5609 17.7174 15.4348 17.9922C15.4045 18.0581 15.3373 18.0979 15.2648 18.0979H11.6587C11.5862 18.0979 11.519 18.0581 11.4888 17.9922C11.3627 17.7174 11.2924 17.4118 11.2924 17.0897C11.2924 15.8926 12.2637 14.9221 13.4618 14.9221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5541,
    cy: 17.302,
    rx: 1.67934,
    ry: 1.67994,
    fill: "#647071"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.554,
    cy: 17.302,
    rx: 0.873259,
    ry: 0.873568,
    fill: "#0F1511"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0373,
    cy: 16.7282,
    rx: 0.223498,
    ry: 0.223578,
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3245 14.9219C24.6812 14.9132 24.2784 15.3622 24.1574 15.5877C23.8091 15.439 23.2796 15.1103 23.418 14.7892C23.5564 14.4681 24.0098 14.495 24.2854 14.5731C23.9175 14.7201 23.8444 14.9709 23.8538 15.0779C24.5071 14.5775 25.1065 14.7654 25.3245 14.9219Z",
    fill: "#1E0D10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7312 15.4059C25.0879 15.3972 24.685 15.8462 24.5641 16.0717C24.2158 15.923 23.6863 15.5943 23.8247 15.2732C23.963 14.9521 24.4165 14.979 24.6921 15.0571C24.3242 15.2041 24.251 15.4549 24.2604 15.5619C24.9138 15.0615 25.5132 15.2494 25.7312 15.4059Z",
    fill: "#1E0D10"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_102_5262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 14,
    width: 6,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2909 14.7031C23.6494 14.7031 24.7507 15.8034 24.7507 17.1608C24.7507 17.5316 24.6685 17.8832 24.5214 18.1984C24.4907 18.2641 24.4236 18.304 24.3511 18.304H20.2307C20.1582 18.304 20.0911 18.2641 20.0605 18.1984C19.9133 17.8832 19.8312 17.5316 19.8312 17.1608C19.8312 15.8034 20.9324 14.7031 22.2909 14.7031Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_102_5262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2909 14.7031C23.6494 14.7031 24.7507 15.8034 24.7507 17.1608C24.7507 17.5316 24.6685 17.8832 24.5214 18.1984C24.4907 18.2641 24.4236 18.304 24.3511 18.304H20.2307C20.1582 18.304 20.0911 18.2641 20.0605 18.1984C19.9133 17.8832 19.8312 17.5316 19.8312 17.1608C19.8312 15.8034 20.9324 14.7031 22.2909 14.7031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.2069,
    cy: 17.2986,
    rx: 2.00324,
    ry: 2.00396,
    fill: "#647071"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.207,
    cy: 17.2986,
    rx: 1.04169,
    ry: 1.04206,
    fill: "#0F1511"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.8006,
    cy: 16.6153,
    rx: 0.231339,
    ry: 0.231422,
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8386 22.3436L22.8805 22.472C23.613 22.5029 24.1163 23.2209 23.8955 23.92C23.5031 24.908 22.5239 25.5355 21.4623 25.4794L20.0573 25.4051C19.4933 25.3753 18.9287 25.4535 18.394 25.6354L17.7044 25.87C16.6324 26.2348 15.4835 26.3127 14.372 26.0961L12.794 25.7886C12.0877 25.6509 11.4667 25.2342 11.0715 24.6328L10.9047 24.3789C10.7916 24.2067 10.7191 24.011 10.6929 23.8066C10.6599 23.5494 10.9004 23.342 11.15 23.4125L12.1322 23.6896C12.6699 23.8414 13.2341 23.8754 13.7863 23.7893L14.923 23.6121C15.4302 23.533 15.9299 23.4115 16.4167 23.2487L18.6006 22.5184C18.9991 22.3851 19.4187 22.3259 19.8386 22.3436Z",
    fill: "#8A766C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.6091 24.8238L10.907 24.5718C10.7969 24.5323 10.7586 24.3962 10.8318 24.305C10.8556 24.2754 10.8885 24.2546 10.9255 24.246L14.7813 23.338C14.8729 23.3165 14.966 23.3015 15.0597 23.2934L20.2337 22.8435L23.6081 22.5994C23.9881 22.572 24.2617 22.9575 24.1102 23.3071C24.0839 23.3679 24.0459 23.423 23.9983 23.4692L23.5809 23.875C23.3223 24.1263 22.9992 24.3012 22.6473 24.3801L21.5087 24.6357L20.0393 24.7667C19.9102 24.7782 19.7802 24.7769 19.6514 24.7626L18.2654 24.6095C18.0995 24.5912 17.9367 24.5517 17.7809 24.492L16.3215 23.9327C15.9095 23.7749 15.4562 23.7611 15.0354 23.8938L12.0572 24.8326C11.9109 24.8787 11.7535 24.8757 11.6091 24.8238Z",
    fill: "#151011"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1193 20.2432L16.4389 19.947L19.9924 20.0951C20.9301 20.918 21.9025 21.1714 22.7711 21.3294C23.6397 21.4874 24.153 22.0864 24.301 22.3662C24.5653 22.8068 23.942 23.4933 23.3987 23.9477C23.0578 24.2327 22.6272 24.3725 22.1858 24.4237L21.1447 24.5447C20.9691 24.565 20.792 24.5705 20.6155 24.561L19.1975 24.4843C19.1026 24.4792 19.0088 24.4625 18.918 24.4347L16.0503 23.5576C15.8838 23.5066 15.708 23.4916 15.5381 23.5301C14.5645 23.7511 12.8286 24.4405 12.0725 24.4766C11.2434 24.5161 10.5809 24.346 9.71891 23.7437C9.21248 23.4802 8.95803 23.1252 9.00738 22.9771C9.28376 22.1871 10.5713 22.6656 11.361 22.32C12.1507 21.8066 12.54 21.8889 12.7868 21.4775C12.7473 20.8851 13.6587 20.4078 14.1193 20.2432Z",
    fill: "#E0E0CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_102_5262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 19,
    width: 16,
    height: 6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1193 20.2432L16.4389 19.947L19.9924 20.0951C20.9301 20.918 21.9025 21.1714 22.7711 21.3294C23.6397 21.4874 24.153 22.0864 24.301 22.3662C24.5653 22.8068 23.942 23.4933 23.3987 23.9477C23.0578 24.2327 22.6272 24.3725 22.1858 24.4237L21.1447 24.5447C20.9691 24.565 20.792 24.5705 20.6155 24.561L19.1975 24.4843C19.1026 24.4792 19.0088 24.4625 18.918 24.4347L16.0503 23.5576C15.8838 23.5066 15.708 23.4916 15.5381 23.5301C14.5645 23.7511 12.8286 24.4405 12.0725 24.4766C11.2434 24.5161 10.5809 24.346 9.71891 23.7437C9.21248 23.4802 8.95803 23.1252 9.00738 22.9771C9.28376 22.1871 10.5713 22.6656 11.361 22.32C12.1507 21.8066 12.54 21.8889 12.7868 21.4775C12.7473 20.8851 13.6587 20.4078 14.1193 20.2432Z",
    fill: "#E0E0CE"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_102_5262)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.9745 23.7365L20.3249 25.016C20.2613 25.1412 20.3446 25.2908 20.4843 25.3028C20.5674 25.3099 20.646 25.2641 20.6809 25.1884L21.128 24.2173C21.3078 23.8267 21.6275 23.5176 22.0239 23.351L22.5181 23.1433C22.7551 23.0437 23.0036 22.974 23.2579 22.9358L25.2249 22.6402C25.2628 22.6345 25.2951 22.6096 25.3102 22.5744C25.3432 22.4974 25.2821 22.4131 25.1987 22.4205L22.798 22.6337C22.5739 22.6536 22.3568 22.722 22.1618 22.8343L21.4323 23.2541C21.2361 23.367 21.077 23.5346 20.9745 23.7365Z",
    fill: "#8A766C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.958 23.9005L20.9493 23.9175C20.6855 24.4295 21.1985 24.9943 21.7332 24.7805C21.7818 24.7611 21.8327 24.7479 21.8846 24.7412L25.0009 24.3392C25.4831 24.277 25.8145 23.8231 25.727 23.3448C25.6515 22.9323 25.2861 22.6368 24.867 22.6496L24.1805 22.6704C24.0796 22.6734 23.9792 22.6858 23.8805 22.7072L22.3084 23.0491C21.9752 23.1215 21.663 23.2695 21.3959 23.4816L21.1262 23.6957C21.0563 23.7513 20.9989 23.8211 20.958 23.9005Z",
    fill: "#C1AE9A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.1674 22.1265L15.1378 22.4295L16.4677 22.2564L18.3124 20.5679L16.1674 22.1265Z",
    fill: "#7C3B26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.9336 21.1154L12.9484 22.4295L13.1867 22.26L13.9336 21.1154Z",
    fill: "#7C3B26"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_102_5262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 3,
    height: 2
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2605 20.6283L18.0555 21.7892C18.0282 21.8154 18.0505 21.8612 18.0879 21.856L19.7119 21.6304C19.7339 21.6273 19.7554 21.6174 19.7722 21.6027C20.489 20.9728 19.8287 20.6773 19.3576 20.5975C19.3222 20.5915 19.2864 20.6034 19.2605 20.6283Z",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_102_5262)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.2605 20.6283L18.0555 21.7892C18.0282 21.8154 18.0505 21.8612 18.0879 21.856L19.7119 21.6304C19.7339 21.6273 19.7554 21.6174 19.7722 21.6027C20.489 20.9728 19.8287 20.6773 19.3576 20.5975C19.3222 20.5915 19.2864 20.6034 19.2605 20.6283Z",
    fill: "#7C3B26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.76,
    cx: 18.9561,
    cy: 20.5889,
    rx: 0.888364,
    ry: 0.888679,
    fill: "#78645D"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_102_5262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 17,
    width: 7,
    height: 4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0572 19.552C14.5439 19.5125 14.1524 20.2267 14.0208 20.5888C14.3761 20.6678 14.7282 20.3913 14.8598 20.2432C14.9387 20.0852 15.2546 20.1445 15.4027 20.1938C16.903 20.7073 18.4626 20.3091 19.0548 20.0457L20.6835 20.8357C20.8019 20.1247 19.7787 19.6179 19.2522 19.4533C19.4102 18.3474 18.5613 17.9063 18.1171 17.824H16.4884C16.0442 17.824 15.6001 18.3013 15.4027 18.614C15.0868 18.6535 15.0407 19.2558 15.0572 19.552Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_102_5262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0572 19.552C14.5439 19.5125 14.1524 20.2267 14.0208 20.5888C14.3761 20.6678 14.7282 20.3913 14.8598 20.2432C14.9387 20.0852 15.2546 20.1445 15.4027 20.1938C16.903 20.7073 18.4626 20.3091 19.0548 20.0457L20.6835 20.8357C20.8019 20.1247 19.7787 19.6179 19.2522 19.4533C19.4102 18.3474 18.5613 17.9063 18.1171 17.824H16.4884C16.0442 17.824 15.6001 18.3013 15.4027 18.614C15.0868 18.6535 15.0407 19.2558 15.0572 19.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.512,
    cy: 19.7989,
    rx: 0.987071,
    ry: 0.987421,
    fill: "#C9CABB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.351,
    cy: 19.3545,
    rx: 0.740303,
    ry: 0.740566,
    fill: "#C9CABB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.2182,
    cy: 20.2433,
    rx: 0.740303,
    ry: 0.740566,
    fill: "#C9CABB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.9926,
    cy: 20.1938,
    rx: 0.987071,
    ry: 0.987421,
    fill: "#C9CABB"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.1889 13.1671L26.2596 12.9598C26.6202 12.9551 26.8993 13.2742 26.8469 13.6309L26.6955 14.6604C26.6092 15.2472 26.0982 15.677 25.5053 15.6614L11.2856 15.2879C10.6286 15.2706 10.1143 14.7165 10.1459 14.06L10.1889 13.1671Z",
    fill: "#0F1511"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_102_5262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 2,
    width: 20,
    height: 10
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7881 2.13971C13.541 2.12562 9.27594 6.36932 9.26187 11.6183L28.2634 11.6693C28.2775 6.42034 24.0352 2.15379 18.7881 2.13971Z",
    fill: "#FFD25C"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_102_5262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7881 2.13971C13.541 2.12562 9.27594 6.36932 9.26187 11.6183L28.2634 11.6693C28.2775 6.42034 24.0352 2.15379 18.7881 2.13971Z",
    fill: "#5791E9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.7489,
    cy: 7.66206,
    rx: 10.7489,
    ry: 7.66206,
    transform: "matrix(0.999996 0.00268593 -0.00268024 0.999996 12.6883 3.53986)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.94666,
    cy: 6.37432,
    rx: 8.94666,
    ry: 6.37432,
    transform: "matrix(0.999996 0.00268593 -0.00268024 0.999996 14.487 4.8324)",
    fill: "#5791E9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.887,
    cy: 4.95781,
    rx: 6.887,
    ry: 4.95781,
    transform: "matrix(0.999996 0.00268593 -0.00268024 0.999996 16.5429 6.25446)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.18369,
    cy: 3.02619,
    rx: 4.18369,
    ry: 3.02619,
    transform: "matrix(0.999996 0.00268593 -0.00268024 0.999996 19.241 8.19336)",
    fill: "#5791E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.1873 11.8766C24.9207 7.19121 19.8353 2.59315 12.6937 1.54381C21.0415 -0.751713 34.24 7.43945 37.5107 11.9124C32.742 14.0459 23.4538 16.5621 24.1873 11.8766Z",
    fill: "#0F1511"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_102_5262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10,
    width: 24,
    height: 4
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22.8019,
    height: 3.59042,
    rx: 1.28906,
    transform: "matrix(0.999996 0.00268497 -0.00268119 0.999996 7.47058 10.3463)",
    fill: "#FFD25C"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_102_5262)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8019,
    height: 3.59042,
    rx: 1.28906,
    transform: "matrix(0.999996 0.00268497 -0.00268119 0.999996 7.47058 10.3463)",
    fill: "#7CB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.0774 12.863C26.8108 8.17754 21.7255 3.57948 14.5838 2.53013C22.9316 0.234614 36.1302 8.42578 39.4008 12.8988C34.6321 15.0322 25.344 17.5484 26.0774 12.863Z",
    fill: "#4674BA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.507812,
    height: 0.15625,
    rx: 0.078125,
    transform: "matrix(0.999996 0.00268584 -0.00268032 0.999996 26.4184 12.2053)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.507812,
    height: 0.15625,
    rx: 0.078125,
    transform: "matrix(0.999996 0.00268584 -0.00268032 0.999996 27.1215 12.2072)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.507812,
    height: 0.15625,
    rx: 0.078125,
    transform: "matrix(0.999996 0.00268584 -0.00268032 0.999996 27.8246 12.2091)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.507812,
    height: 0.15625,
    rx: 0.078125,
    transform: "matrix(0.999996 0.00268584 -0.00268032 0.999996 28.5278 12.211)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.507812,
    height: 0.15625,
    rx: 0.078125,
    transform: "matrix(0.999996 0.00268585 -0.00268032 0.999996 7.42603 12.1544)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.507812,
    height: 0.15625,
    rx: 0.078125,
    transform: "matrix(0.999996 0.00268585 -0.00268032 0.999996 8.12915 12.1562)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.507812,
    height: 0.15625,
    rx: 0.078125,
    transform: "matrix(0.999996 0.00268585 -0.00268032 0.999996 8.83228 12.1581)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_5262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 9.76562,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.194e75f71b2dd34a7fb9cbe6551c9e7d.svg";
export { ForwardRef as ReactComponent };